import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RadioItemComponent } from '@app/components/pl-radio/radioItem/radioItem.component';

@NgModule({
  imports: [CommonModule, PlIconModule, SharedModule, FormsModule],
  declarations: [RadioItemComponent],
  exports: [RadioItemComponent],
})
export class RadioItemModule {}
